export function getQueryName(
	operationName: string | null | undefined,
	variables: any,
	sanitize: boolean = false,
) {
	if (!operationName) return '';

	let name = operationName;
	if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') {
		name = `${operationName}:${
			variables?.location || (variables?.locations || []).join(',') || ''
		}`;
	} else if (operationName === 'FetchPreFilteredForgeAppsQuery') {
		name = `${operationName}:${variables?.types?.join(',') || ''}`;
	}
	if (sanitize) {
		return name.replace(/[^\-\.\w]/g, '_');
	}
	return name;
}
